import React from "react";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import isDraftFilterAtLocation from "@qpr/client-api-base/attributes/drafts/disabledPages";
import { IPeriod } from "backend/model/model";
import { usePeriod } from "backend/model/usePeriod";
import getValues from "backend/values";

import { useQuery } from "react-query";
import usePeriodLevels from "../model/usePeriodLevels";
import usePeriodFromString from "../model/usePeriodFromString";

const useElement = (id?: string, period?: string) => {
  const ctx = useAppContext();
  const currentPeriod = usePeriodFromString(period);
  const { data: periodLevels } = usePeriodLevels();
  return useQuery(
    `data-element-useElement-${id || ctx.elementId}-${
      currentPeriod?.name || ""
    }-${isDraftFilterAtLocation()}`,
    () => {
      return getValues(
        id || ctx.elementId || "",
        currentPeriod ? [currentPeriod] : [],
        true,
        periodLevels!
      ).then((list) => {
        return list[0];
      });
    },
    {
      enabled: !!currentPeriod && !!periodLevels && !!id,
      cacheTime: 10 * (60 * 1000),
      staleTime: 10 * (60 * 1000),
    }
  );
};

export default useElement;
